module.exports = __webpack_public_path__ + "img/saoma.7be99421.png";